(function () {
    'use strict';

    $('.select-mobile-tabs').select2({
        width: '100%',
        minimumResultsForSearch: -1
    });

    $('.select-mobile-tabs').on('select2:select', function (e) {
        var data = e.params.data;
        $('#' + data.id).siblings().removeClass('active');
        $('#' + data.id).addClass('active');
    });

})();